import { Injectable, signal, computed } from '@angular/core';
import { AuthResult } from '../models/auth.model';


@Injectable({ providedIn: 'root' })
export class SessionService {
    private _isLoggedIn = signal(false);

    /** Readonly signal for template binding */
    readonly loggedIn = computed(() => this._isLoggedIn());
    private readonly STORAGE_KEYS = {
        ACCESS_TOKEN: 'access_token',
        REFRESH_TOKEN: 'refresh_token',
        EXPIRES_IN: 'expires_in',
        LOGIN_TIME: 'login_time',
        IS_LOGGED_IN: 'is_Logged_In',
    } as const;

    constructor() {
        this.initializeFromStorage();
    }

    private initializeFromStorage(): void {
        const isLoggedIn = sessionStorage.getItem(this.STORAGE_KEYS.IS_LOGGED_IN) === 'true';
        this._isLoggedIn.set(isLoggedIn);
    }

    getAccessToken(): string | null {
        return sessionStorage.getItem(this.STORAGE_KEYS.ACCESS_TOKEN);
    }

    getRefreshToken(): string | null {
        return sessionStorage.getItem(this.STORAGE_KEYS.REFRESH_TOKEN);
    }

isTokenExpired(): boolean {
  const accessToken = sessionStorage.getItem('access_token');
  const expiresAtStr = sessionStorage.getItem('expires_at');

  if (accessToken && expiresAtStr) {
    try {
      const expiresAt = JSON.parse(expiresAtStr) as number;
      return new Date().getTime() > expiresAt;
    } catch {
      return true;
    }
  }

  return true;
}

    isLoggedIn(): boolean {
        return this._isLoggedIn();
    }

    setLoggedIn(value: boolean): void {
        this._isLoggedIn.set(value);
        sessionStorage.setItem(this.STORAGE_KEYS.IS_LOGGED_IN, value.toString());
    }

    resetSessionVariables(): void {
        this._isLoggedIn.set(false);
        sessionStorage.removeItem(this.STORAGE_KEYS.IS_LOGGED_IN);
    }

    // clearSession(): void {
    //     Object.values(this.STORAGE_KEYS).forEach(key => {
    //         sessionStorage.removeItem(key);
    //     });

    //     this.resetSessionVariables();
    // }

    // clearAuthTokens(): void {
    //     sessionStorage.removeItem(this.STORAGE_KEYS.ACCESS_TOKEN);
    //     sessionStorage.removeItem(this.STORAGE_KEYS.REFRESH_TOKEN);
    //     sessionStorage.removeItem(this.STORAGE_KEYS.EXPIRES_IN);
    //     sessionStorage.removeItem(this.STORAGE_KEYS.LOGIN_TIME);
    // }
}